import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
// Core components
import Tooltip from 'components/core/Tooltip';
// Custom
import { getHocDisplayName } from 'utils/Tools';

const withTooltip = (WrappedComponent) => {
  const WithTooltip = ({
    tooltip,
    tooltipId,
    tooltipValues,
    tooltipPlacement,
    ...otherProps
  }) => {
    const selectedTooltip = tooltip || tooltipId;
    if (selectedTooltip && !_isEmpty(selectedTooltip)) {
      const tooltipIds = !Array.isArray(selectedTooltip) ? [selectedTooltip] : [...selectedTooltip];
      const tooltipsValues = !Array.isArray(tooltipValues) ? [tooltipValues] : [...tooltipValues];

      const content = tooltipIds.map((id, index) => (
        <div key={id}>
          <LocalizedMessage
            id={id}
            values={tooltipsValues[index]}
          />
        </div>
      ));
      return (
        <Tooltip
          content={content}
          placement={tooltipPlacement}
        >
          <WrappedComponent {...otherProps} />
        </Tooltip>
      );
    }

    return (<WrappedComponent {...otherProps} />);
  };

  WithTooltip.displayName = getHocDisplayName('WithTooltip', WrappedComponent);

  WithTooltip.propTypes = {
    tooltip: PropTypes.string,
    tooltipId: PropTypes.string,
    tooltipValues: PropTypes.object,
    tooltipPlacement: PropTypes.string,
  };

  WithTooltip.defaultProps = {
    tooltip: null,
    tooltipId: null,
    tooltipValues: null,
    tooltipPlacement: 'top',
  };

  return WithTooltip;
};

export default withTooltip;



// WEBPACK FOOTER //
// ./hocs/WithTooltip.js